import { render, staticRenderFns } from "./calendarthismonth.vue?vue&type=template&id=b410881e"
import script from "./calendarthismonth.vue?vue&type=script&lang=js"
export * from "./calendarthismonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports